<template>
  <v-card class="pa-4" elevation="1">
    <div v-if="resumenNoOk.totalNoOk > 0">
      <v-row class="mb-2 cav-row" align="stretch">
        <v-col cols="12">
          <div class="subtitle-2 font-weight-medium mb-2">
            Piezas No OK por causa y subcausa
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <apexchart type="donut" height="260" :options="chartOpts" :series="resumenNoOk.porCausa.map(a => a.total)" />
        </v-col>

        <v-col cols="12" md="8">
          <div class="caption font-weight-medium mb-1">
            Detalle de No OK
          </div>

          <v-data-table :headers="headersDetalles" :items="resumenNoOk.detalles" dense disable-pagination
            hide-default-footer class="no-ok-table">
            <template v-slot:item.cantidad="{ item }">
              <div class="text-right font-weight-medium">
                {{ nf(item.cantidad) }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <div v-else class="text-center caption my-6">
      Sin datos de piezas No OK.
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DialgoNoOkHpH',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    detallesNoOk: {
      type: Array,
      default: null,
    },
  },
  computed: {
    sourceValue() {
      return this.value && typeof this.value === 'object' ? this.value : {};
    },
    noOkRaw() {
      if (Array.isArray(this.detallesNoOk)) return this.detallesNoOk;

      const arr = this.pick(this.sourceValue, ['DetallesNoOk', 'detallesNoOk']);
      return Array.isArray(arr) ? arr : [];
    },
    resumenNoOk() {
      const grupos = new Map();
      let totalNoOk = 0;

      this.noOkRaw.forEach(d => {
        const cantidad = Number(this.pick(d, ['PiezasReportadas', 'piezasReportadas', 'Cantidad', 'cantidad']) || 0);
        if (cantidad <= 0) return;

        const causaRaw = String(this.pick(d, ['Causa', 'causa']) || '').trim();
        const subCausaRaw = String(this.pick(d, ['SubCausa', 'subCausa']) || '').trim();
        const causa = causaRaw || 'SIN CAUSA';
        const subCausa = subCausaRaw || '-';
        const label = this.labelNoOk(causaRaw, subCausaRaw);

        const key = this.normaliza(`${causa}::${subCausa}`);
        let g = grupos.get(key);
        if (!g) {
          g = { key, label, causa, subCausa, cantidad: 0 };
          grupos.set(key, g);
        }
        g.cantidad += cantidad;
        totalNoOk += cantidad;
      });

      const detalles = Array.from(grupos.values()).sort((a, b) => {
        if (b.cantidad !== a.cantidad) return b.cantidad - a.cantidad;

        const byCausa = String(a.causa || '').localeCompare(String(b.causa || ''));
        if (byCausa !== 0) return byCausa;

        return String(a.subCausa || '').localeCompare(String(b.subCausa || ''));
      });

      return {
        totalNoOk,
        porCausa: detalles.map(item => ({
          key: item.key,
          label: item.label,
          total: item.cantidad,
        })),
        detalles,
      };
    },
    chartOpts() {
      const total = this.resumenNoOk.totalNoOk || 0;
      const labels = this.resumenNoOk.porCausa.map(a => a.label);

      return {
        labels,
        chart: {
          type: 'donut',
          toolbar: { show: false },
        },
        legend: {
          show: true,
          position: 'bottom',
          labels: { useSeriesColors: true },
        },
        tooltip: {
          y: {
            formatter: (value, opts) => {
              const idx = opts.seriesIndex;
              const abs = this.resumenNoOk.porCausa[idx]?.total || 0;
              if (!total) return `${this.nf(value)} pza(s)`;
              const pct = (abs / total) * 100;
              return `${this.nf(abs)} pza(s) (${pct.toFixed(1)}%)`;
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            const abs = opts.w.globals.series[opts.seriesIndex] || 0;
            if (!total) return '';
            const pct = (abs / total) * 100;
            return `${pct.toFixed(1)}%`;
          },
          style: { fontSize: '11px' },
        },
        stroke: { width: 2 },
        colors: ['#EF5350', '#FB8C00', '#8E24AA', '#26A69A', '#1E88E5', '#5E35B1'],
      };
    },
    headersDetalles() {
      return [
        { text: 'Causa', value: 'causa' },
        { text: 'Subcausa', value: 'subCausa' },
        { text: 'Cantidad', value: 'cantidad', align: 'end' },
      ];
    },
  },
  methods: {
    pick(obj, keys) {
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];
        if (obj && obj[k] != null) return obj[k];
      }
      return undefined;
    },
    normaliza(txt) {
      return String(txt || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    labelNoOk(causa, subCausa) {
      const c = String(causa || '').trim();
      const s = String(subCausa || '').trim();
      if (c && s) return `${c} - ${s}`;
      if (c) return c;
      if (s) return s;
      return 'SIN CAUSA';
    },
    nf(n) {
      return Number(n ?? 0).toLocaleString();
    },
  },
};
</script>

<style scoped>
.no-ok-table>>>.v-data-table__wrapper {
  max-height: 260px;
}

.cav-row+.cav-row {
  border-top: 1px solid #eee;
  padding-top: 12px;
}
</style>
